import './necat/style';
import FormStructure from './necat/form_structure';

export default FormStructure;